import { Gift, Cart } from '@/app/shared/interface/cart.interface';
import { GiftService } from '@/app/shared/services/gift.service';
import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-gift-list-modal',
  templateUrl: './gift-list-modal.component.html',
  styleUrl: './gift-list-modal.component.scss',
})
export class GiftListModalComponent {

  @ViewChild('giftModal', { static: false }) giftModal: any;

  giftList: Gift[] = [];
  cart: Cart;

  public gridClass: string = 'g-3 g-sm-4 product-list-section row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4';

  deviceWidth: number = 0;

  public closeResult: string;
  public modalOpen: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.deviceWidth = (event.target as Window).innerWidth;
    this.setGridItems();
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalService: NgbModal,
    private giftService: GiftService,
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    this.giftService.exchangedGifts$.subscribe({
      next: (gifts: any) => {
        if (gifts) {
          this.giftList = gifts;
        }
      }
    });

    this.setGridItems();
  }

  setGridItems() {
    if (this.deviceWidth < 392) {
      this.gridClass = 'row g-3 product-list-section row-cols-1 m-auto';
    } else if (this.deviceWidth >= 392 && this.deviceWidth < 576) {
      this.gridClass =
        'row g-sm-4 g-3 g-xl-4 g-lg-4 product-list-section row row-cols-xxl-6 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 product-list-section m-auto';
    } else if (this.deviceWidth >= 576 && this.deviceWidth < 768) {
      this.gridClass =
        'g-3 g-sm-4 product-list-section row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-3';
    } else if (this.deviceWidth >= 768 && this.deviceWidth < 1024) {
      this.gridClass =
        'g-3 g-sm-4 product-list-section row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4';
    } else if (this.deviceWidth >= 1024 && this.deviceWidth < 1440) {
      this.gridClass =
        'g-3 g-sm-4 product-list-section row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4';
    } else {
      this.gridClass =
        'g-3 g-sm-4 product-list-section row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4';
    }
  }

  async openModal() {
    if (isPlatformBrowser(this.platformId)) { // For SSR
      this.modalOpen = true;
      let modal = this.modalService.open(this.giftModal, {
        ariaLabelledBy: 'Gift-Modal',
        centered: true,
        windowClass: 'theme-modal modal-xl',
        backdrop: 'static',
      });

      // modal.shown.subscribe(() => {
        
      // });

      modal.result.then((result) => {
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.confirm(false);
      });
    }
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  confirm(value: boolean) {
    if (value) {
      
    }
    this.modalService.dismissAll();
  }
}
